import * as React from "react"
import { TaxStatus, type Transaction } from "@digits-graphql/frontend/graphql-bearer"

const TAX_STATUS_DISPLAY_TEXT: Map<TaxStatus, string> = new Map([
  [TaxStatus.Taxable, "1099 Qualified"],
  [TaxStatus.NonTaxable, "1099 Unqualified"],
  [TaxStatus.Undetermined, "Unknown"],
  [TaxStatus.UnspecifiedTaxStatus, "Unknown"],
])

const MULTIPLE_SPLIT_CATEGORY_ID = "multiple-split-category-id"
const MULTIPLE_SPLIT_CATEGORY_NAME = "Multiple"

export function usePlaceholders(transactions: Transaction[]) {
  return React.useMemo(() => {
    const categories = new Map<string, string>()
    const parties = new Map<string, string>()
    const reconciliationStatuses = new Set<string>()
    const taxStatuses = new Set<TaxStatus>()
    const splitCategories = new Map<string, string>()

    Array.from(transactions).forEach((transaction) => {
      categories.set(transaction.displayCategory.id, transaction.displayCategory.name)
      const splitId = transaction.splitCategory?.id
        ? transaction.splitCategory.id
        : MULTIPLE_SPLIT_CATEGORY_ID
      const splitName = transaction.splitCategory?.name || MULTIPLE_SPLIT_CATEGORY_NAME
      splitCategories.set(splitId, splitName)

      transaction.party
        ? parties.set(transaction.party.id, transaction.party.name)
        : parties.set("No Party", "No Party")

      reconciliationStatuses.add(transaction.reconciliationStatus)

      taxStatuses.add(transaction.taxStatus)
    })

    return {
      partyPlaceholder: parties.size === 1 ? Array.from(parties.values())[0] : "Multiple",
      categoryPlaceholder: categories.size === 1 ? Array.from(categories.values())[0] : "Multiple",
      splitCategoryPlaceholder:
        splitCategories.size === 1 && !splitCategories.has(MULTIPLE_SPLIT_CATEGORY_ID)
          ? Array.from(splitCategories.values())[0]
          : MULTIPLE_SPLIT_CATEGORY_NAME,
      reconciliationStatusPlaceholder:
        reconciliationStatuses.size === 1 ? Array.from(reconciliationStatuses)[0] : "Multiple",
      taxStatusPlaceholder:
        taxStatuses.size === 1
          ? TAX_STATUS_DISPLAY_TEXT.get(
              Array.from(taxStatuses)[0] || TaxStatus.UnspecifiedTaxStatus
            )
          : "Multiple",
    }
  }, [transactions])
}
